import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
// import "./../assets/css/hamburger.css";

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <section className="nav-section" id="nav">
      <div className="logo">
        <span>Ilann BARRETEAU</span>
        <span>Web Developer</span>
      </div>
      {/* <button
        className={`hamburger hamburger--collapse mobile ${
          isOpen ? "is-active" : ""
        }`}
        type="button"
        onClick={toggleMenu}
        aria-controls="basic-navbar-nav"
        aria-expanded={isOpen}
        aria-label="Toggle navigation"
      >
        <span className="hamburger-box">
          <span className="hamburger-inner"></span>
        </span>
      </button> */}
      <nav className={isOpen ? "show" : ""}>
        <Link to="/#about" onClick={toggleMenu} className="btn">
          À propos
        </Link>
        <Link to="/#skills" onClick={toggleMenu} className="btn">
          Compétences
        </Link>
        <Link to="/#project" onClick={toggleMenu} className="btn">
          Réalisations
        </Link>
        <Link to="/#parcours" onClick={toggleMenu} className="btn">
          Parcours
        </Link>
        <Link to="/#contact" onClick={toggleMenu} className="btn">
          Contact
        </Link>
      </nav>
    </section>
  );
};
export default Nav;
